//アプリ情報読込み
var listsz = [];
var optionlistz = ["セール商品"];
var displayCountz = 0;

//チェックボックスの備考メッセージ
var checkBoxMessagez ="※同意するにチェックをしてカートに入れるを押してください。";
var checkBoxCountz = 0;
var checkBoxCountLimitz = 0;

//カスタムオーダールール呼び出し
var loadRulesIntervalz = setInterval(() => {
  window.customorderLoadRules(function () {
    window.GroovyCustomOrder.rules.forEach(function (rule) {

      if (rule != null) {
        if(optionlistz.indexOf(rule.name) !== -1) {
          rule.data.forEach(function (ru) {
            listsz.push(ru);
          })
        }
      }
    });

  });
  if (listsz.length > 0) {
    clearInterval(loadRulesIntervalz);
    createSorceCodez(listsz);
  }
}, 2500)

//商品ページへオプションの埋め込み
function createSorceCodez(optionlistz) {
  displayCountz++;
  //各要素のカウント
  checkBoxCountLimitz = optionlistz.filter(n => n.type === 'checkbox').length;
  
  if(displayCountz === 1){
    var html = ``;
    optionlistz.forEach(function(option) {
      switch (option.type) {
        case "choices" :
          html += createChoices(option);
          break;
        case "select" :
          html += createDropDown(option);
          break;        
        case "checkbox" :
          html += createCheckBoxz(option);
          break;
        default:
          break;
      }
    });
    
    var customOrderOptionsElementz = document.getElementById('customOrderOptions');
    customOrderOptionsElementz.insertAdjacentHTML('afterbegin', html);
    
  }
}

//オプションタイプ　チェックボックス
function createCheckBoxz(element) {
  checkBoxCountz++;
  var html = ``;
  html = `<div class="customOrderOption">
            <div class="customOrderOptionTitlex">${element.name}</div>
            <div class="customOrderOptionElement checkBoxCustom">
              <input type="checkbox" class="${optionlistz[0]}" id="checkBox${checkBoxCountz}x" name="properties[${element.name}]" value="${element.note}">           
              <span class="checkboxTitle">${element.note}</span>
            </div>
            <span class="customorderErrorx"><small>必須項目のため、選択してください / This option is required.</small></span> 
          </div>`;

  if(checkBoxCountz === checkBoxCountLimitz) {
    html += `<span class="customHelpText"><small>${checkBoxMessagez}</small></span>`;
  }
  
  return html;
}

